import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header';
import PrimaryBox from '../../components/PrimaryBox';
import SiteExpensesTable from '../../components/tables/operations/expenses/SiteExpensesTable';
import { usePageTitle } from '../../hooks/usePageTitle';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import { getTomorrowDate, isSameDayOrAfter, isSameDayOrBefore } from '../../utils/dates';
import { localStorageKeys } from '../../utils/enums';
import { getItemFromLocalStorage, storeItemToLocalStorage } from '../../utils/localStorage';

const ExpensesPage: React.FC = () => {
    const { t } = useTranslation();
    usePageTitle(capitalizeFirstLetter(t('expenses')));
    const [firstDate, setFirstDate] = useState(new Date(getItemFromLocalStorage(localStorageKeys.REPORTINGSTARTDATE) || new Date()));
    const [secondDate, setSecondDate] = useState(new Date(getItemFromLocalStorage(localStorageKeys.REPORTINGENDDATE) || getTomorrowDate()));

    const handleFirstDateChange = (newDate: string) => {
        const tmpDate = new Date(newDate);
        if (!isSameDayOrBefore(tmpDate, secondDate)) return;
        setFirstDate(tmpDate);
        storeItemToLocalStorage(localStorageKeys.REPORTINGSTARTDATE, newDate);
    };

    const handleSecondDateChange = (newDate: string) => {
        const tmpDate = new Date(newDate);
        if (!isSameDayOrAfter(tmpDate, firstDate)) return;
        setSecondDate(tmpDate);
        storeItemToLocalStorage(localStorageKeys.REPORTINGENDDATE, newDate);
    };

    return (
        <PrimaryBox>
            <Header
                title={t('operations')}
                breadcrumbs={[{ label: capitalizeFirstLetter(t('expenses')) }]}
                subTitle={capitalizeFirstLetter(t('expenses')) + ' (' + t('beta') + ')'}
                isSecondDateVisible
                initialDate={firstDate}
                onDateChange={(newDate) => handleFirstDateChange(newDate.toISOString())}
                initialSecondDate={secondDate}
                onSecondDateChange={(newDate) => handleSecondDateChange(newDate.toISOString())}
                shortDate
                shortSecondDate
            ></Header>

            <SiteExpensesTable startDate={firstDate} endDate={secondDate} />
        </PrimaryBox>
    );
};

export default ExpensesPage;
